import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var DigitalTranslationsUniques = function DigitalTranslationsUniques() {
  return /*#__PURE__*/React.createElement("div", {
    className: "uniques"
  }, /*#__PURE__*/React.createElement("div", {
    className: "unique"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-3 float-start align-middle",
    icon: "fa-solid fa-tachometer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-unique-1"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "unique"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-3 float-start align-middle",
    icon: "fa-solid fa-graduation-cap"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-unique-2"
  }))));
};
export default DigitalTranslationsUniques;